import { apiClient } from '@/lib/api/client';
import { endpoints } from '@/lib/api/endpoints';

import { userSchema } from './schemas';
import type { LoginRequest, User } from './types';

export async function fetchCurrentUser(): Promise<User> {
  const res = await apiClient.get(endpoints.auth.me);
  return userSchema.parse(res.data.data);
}

export async function login(body: LoginRequest): Promise<User> {
  const res = await apiClient.post(endpoints.auth.login, body);
  return userSchema.parse(res.data.data);
}

export async function logout(): Promise<void> {
  await apiClient.post(endpoints.auth.logout);
}
